<template>
  <div>
    <v-row justify="center">
      <v-col class="pl-10 pr-10">
        <CustomFileInput
          v-model="selectedImages"
          multiple
          data-cy="node_image_input"
          :backendFiles="files || []"
          @removeFiles="removeFiles"
          @change="saveFile"
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import CustomFileInput from '@/components/shared/CustomFileInput';
import lockService from '@/utilities/lockService';


export default {
    components: {
        CustomFileInput,
    },
    props: {
        node: {
            type: Object,
            default: null,
        },
        actionName: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            files: [],
            selectedImages: [],
            imageFiles: [],
            update: false,
        };
    },
    computed: {
        ...mapGetters([
            'hasPermission',
        ]),

    },

    async created() {
        await this.getNode();
    },
    mounted() {
        window.addEventListener('beforeunload', this.handleUnload);
    },

    beforeDestroy() {
        if (this.node && this.node.ref) {
            lockService.releaseLock(this.node.ref, this.actionName);
        }
        window.removeEventListener('beforeunload', this.handleUnload);
    },
    methods: {
        async getNode() {
            const { data: node } = await this.$rq.getNode(this.node.ref, this.node.nodeType);
            this.files.push(...node.files);
            // remove duplicated files for auto saving
            this.files = this.files.filter((value, index, self) => index === self.findIndex(t => (
                t.id === value.id
            )));
        },
        handleUnload() {
            if (this.node && this.node.ref) {
                lockService.releaseLock(this.node.ref, this.actionName);
            }
        },
        async saveFile() {
            /* By selecting image, file automatically saved.
               when user click on confirm button the file conncets to the node
               and becomes completly save
            */
            this.isUploading = true;
            const promises = [];
            this.selectedImages.forEach(imageFile => {
                const formData = new FormData();
                formData.append('file', imageFile);
                promises.push(this.addFile(formData));
            });

            const files = await Promise.all(promises);
            // added image(s) id
            const addedFileIds = files.map(file => file.id);
            // node image(s) id
            const fileIds = this.files.map(file => file.id);
            this.files.push(...files);
            this.update = !this.update;
            this.$emit('sendData', { files: [...fileIds, ...addedFileIds] });

            await this.getNode();
            this.selectedImages = [];
        },
        async addFile(formData) {
            const { data } = await this.$rq.addFile(null, formData);
            return data;
        },

        async removeFiles(fileId) {
            const newFiles = this.files.filter(f => f.id !== fileId);
            this.files = newFiles;
            const files = newFiles.map(f => f.id);
            this.$emit('sendData', { files: [...files], fileToRemove: fileId });
        },
    },
};
</script>
